const AccessGuidePage = () => {
  const pdfUrl = "docs/access-guide.pdf";

  return (
    <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
      <iframe
        src={pdfUrl}
        title="Access Guide PDF"
        width="100%"
        height="100%"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default AccessGuidePage;
